export default {
  header: 'Ups, noget uventet skete',
  text: 'Genindlæs siden, eller klik på knappen “Tilbage til menuen” nedenfor.',
  button: 'Tilbage til menuen',
};
